import React from 'react';

const SaveSVG = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      className={className}
    >
      <path
        d="M13.7083 19.3333V13.7083H6.95825V19.3333M17.0833 19.3333H3.58325C2.34061 19.3333 1.33325 18.3259 1.33325 17.0833V3.58325C1.33325 2.34061 2.34061 1.33325 3.58325 1.33325H12.7763C13.373 1.33325 13.9453 1.5703 14.3673 1.99227L18.6742 6.29924C19.0962 6.7212 19.3333 7.29349 19.3333 7.89024V17.0833C19.3333 18.3259 18.3259 19.3333 17.0833 19.3333Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SaveSVG;
